import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import HeaderDashboard from "../components/HeaderDashboard";
import { Box, Typography, Chip, Button, LinearProgress, Avatar, CircularProgress } from "@mui/material";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import BusinessIcon from "@mui/icons-material/Business";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import FolderOffOutlinedIcon from "@mui/icons-material/FolderOffOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import ViewQuiltOutlinedIcon from "@mui/icons-material/ViewQuiltOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AddIcon from "@mui/icons-material/Add";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import BoltIcon from "@mui/icons-material/Bolt";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import { useTour } from "@reactour/tour";
import { useUser } from "../../contexts/UserContext";
import { MascaraCnpj } from "../../utils/MascaraCnpj";
import TourDashboard, { isPrimeiroAcesso } from "./components/TourDashboard";

const icones = {
    VerifiedUserOutlinedIcon: VerifiedUserOutlinedIcon,
    FolderOffOutlinedIcon: FolderOffOutlinedIcon
}


const Dashboard = () => {
    const navigate = useNavigate();
    const { user } = useUser();
    const { setIsOpen: abrirTour, setCurrentStep: setPassoTour } = useTour();

    const [usuario, setUsuario] = useState(null);
    const [situacaoEmpresa, setSituacaoEmpresa] = useState(null);

    const iniciarTour = () => {
        setPassoTour(0);
        abrirTour(true);
    };

    // Primeiro acesso: abre o tour depois que o resumo carrega, para os cards já estarem no lugar
    const primeiroAcesso = isPrimeiroAcesso(user);
    useEffect(() => {
        if (primeiroAcesso && usuario) iniciarTour();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [primeiroAcesso, usuario]);


    useEffect(() => {
        const getResumoDashboard = async () => {
            try {
                const resumo = await axios.get(`${process.env.REACT_APP_API_URL}/getResumoDashboard`, {
                    headers: {
                        Authorization: localStorage.getItem('token'),
                    }
                });

                console.log("Resumo do dashboard:", resumo.data);
                setUsuario(resumo.data.usuario);
                setSituacaoEmpresa(resumo.data.situacaoEmpresa);
            } catch (error) {
                console.error("Erro ao obter resumo do dashboard:", error);
            }
        };
        getResumoDashboard();
    }, [user]);

    if (!user?.usuario) {
        return (
            <>
                <HeaderDashboard />
                <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2 }}>
                    <CircularProgress sx={{ color: "#0b243d" }} />
                    <Typography sx={{ fontSize: 14, color: "#6b7280" }}>Carregando seus dados...</Typography>
                </Box>
            </>
        );
    }

    // const usuario = {
    //     nome: user?.usuario?.Nome.split(" ")[0] || false,
    //     cnpj: user?.empresa?.cnpj || false,
    //     razaoSocial: user?.empresa?.razaoSocial || false,
    //     regime: user?.empresa?.regimeTributario || false,
    //     plano: `Plano ${user?.plano?.nome}` || false,
    //     descricaoPlano: user?.plano?.descricao || false,
    //     statusPlano: user?.plano?.ativo ? "REGULAR" : "INATIVO" || false,
    // };


    const resumo = {
        faturamento: 0,
        variacaoFaturamento: 0,
        // /dashboard devolve a quantidade de notas do mês (número)
        notasEmitidas: Number(user?.notasEmitidasEsteMes) || 0,
        mediaPorNota: 0,
    };

    const faturamentoMensal = {
        media: "R$ 38.200/mês",
        variacao: "+12% este mês",
        projecao: "R$ 51.200,00",
        meses: [
            { mes: "Jul", valor: 31200 },
            { mes: "Ago", valor: 34000 },
            { mes: "Set", valor: 38500 },
            { mes: "Out", valor: 36800 },
            { mes: "Nov", valor: 40900 },
            { mes: "Dez", valor: 45800, atual: true },
        ],
    };
    const escalaGrafico = 50000;

    const notasRecentes = {
        competencia: "Mês de " + (new Date().toLocaleString("pt-BR", { month: "long" })),
        totalAberto: Number(0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
        notas: [
            // { tomador: "Clínica Santa Maria", numero: "000284", valor: "R$ 1.500,00", emissao: "29/09", status: "Emitida" },
            // { tomador: "Hospital Albert Einstein ABC", numero: "000283", valor: "R$ 2.300,00", emissao: "27/09", status: "Emitida" },
            // { tomador: "Paciente Particular (Consulta)", numero: "000282", valor: "R$ 850,00", emissao: "25/09", status: "Emitida" },
            // { tomador: "Rede D'Or São Luiz", numero: "000281", valor: "R$ 3.450,00", emissao: "22/09", status: "Emitida" },
        ],
    };

    const contador = {
        nome: "Nome do Contador",
        especialidade: "Especialista Contábil",
        tempoResposta: "< 5 min",
    };

    const iniciais = (texto) =>
        texto.split(" ").filter((p) => /^[A-ZÀ-Ú]/.test(p)).slice(0, 2).map((p) => p[0]).join("");

    const colunasNotas = "minmax(0, 2.4fr) 1fr 0.8fr 0.8fr";

    const dot = <Box component="span" sx={{ width: 4, height: 4, borderRadius: "50%", backgroundColor: "#9ca3af", mx: 1 }} />;

    const cardSx = {
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 2,
        minHeight: 140,
        backgroundColor: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: "12px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        p: 2,
    };

    const valorSx = { fontSize: { xs: 24, md: 26 }, fontWeight: 700, color: "#111827", lineHeight: 1.2 };

    const CardHeader = ({ titulo, icone, destaque }) => (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
            <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.8, color: "#374151", textTransform: "uppercase" }}>
                {titulo}
            </Typography>
            <Box
                sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "8px",
                    backgroundColor: destaque ? "#fef3c7" : "#f3f4f6",
                    color: destaque ? "#d97706" : "#374151",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    "& svg": { fontSize: 18 },
                }}
            >
                {icone}
            </Box>
        </Box>
    );

    // TODO: ligar "Contador" ao fluxo de atendimento
    const acoesRapidas = [
        { label: "Sócios", icone: <PersonOutlinedIcon />, rota: "../Dashboard/FichaCadastral?etapa=socios" },
        { label: "Enviar doc", icone: <UploadFileOutlinedIcon />, rota: "../Dashboard/Documentos" },
        { label: "Serviços", icone: <PostAddOutlinedIcon />, rota: "../Dashboard/Servicos" },
        ...(user.secretaria ? [] : [{ label: "Secretárias", icone: <GroupsOutlinedIcon />, rota: "../Dashboard/Secretarias" }]),
    ];

    const botaoAcaoSx = {
        flex: 1,
        minWidth: 120,
        textTransform: "none",
        fontSize: 13,
        fontWeight: 500,
        color: "#374151",
        backgroundColor: "#f3f4f6",
        borderRadius: "8px",
        boxShadow: "none",
        py: 1,
        "& svg": { fontSize: 18, color: "#6b7280" },
        "&:hover": { backgroundColor: "#e5e7eb", boxShadow: "none" },
    };

    return (
        <>
            <HeaderDashboard />
            <Box sx={{ pt: "80px", px: { xs: 2, md: "5%" } }}>
                <Box
                    data-tour="boas-vindas"
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                        backgroundColor: "#fff",
                        border: "1px solid #e5e7eb",
                        borderRadius: "12px",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                        p: { xs: 2, md: 3 },
                    }}
                >
                    <Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                            <Typography sx={{ fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                                Olá, Doutor<span style={{ fontSize: "15px" }}>(a)</span> {usuario?.nome ? usuario?.nome : "..."} 👋
                            </Typography>
                        </Box>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Confira a situação da sua empresa e suas principais pendências contábeis em tempo real.
                        </Typography>
                        <Box sx={{ mt: 1.5, display: "flex", alignItems: "center", flexWrap: "wrap", fontSize: 12, color: "#6b7280" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                <BadgeOutlinedIcon sx={{ fontSize: 16 }} />
                                CNPJ: {usuario?.cnpj ? MascaraCnpj(usuario?.cnpj) : "Não informado"}
                            </Box>
                            {dot}
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, color: "#374151", fontWeight: 500 }}>
                                <BusinessIcon sx={{ fontSize: 16, color: "#6b7280" }} />
                                {usuario?.razaoSocial ? usuario?.razaoSocial : "Não informado"}
                            </Box>
                            {dot}
                        </Box>
                        <Typography sx={{ mt: 0.5, fontSize: 12, color: "#374151" }}>
                            Regime: {usuario?.regime ? usuario?.regime : "Não informado"}
                        </Typography>
                        <Button
                            size="small"
                            startIcon={<ExploreOutlinedIcon sx={{ fontSize: "16px !important" }} />}
                            onClick={iniciarTour}
                            sx={{ mt: 1, textTransform: "none", fontSize: 12, fontWeight: 600, color: "#6b7280", p: 0, minWidth: 0, "&:hover": { backgroundColor: "transparent", color: "#111827", textDecoration: "underline" } }}
                        >
                            Fazer tour pela plataforma
                        </Button>
                    </Box>

                    <Box
                        data-tour="plano"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            backgroundColor: "#f3f4f6",
                            borderRadius: "10px",
                            p: 1.5,
                            minWidth: { md: 260 },
                        }}
                    >
                        <Box
                            sx={{
                                width: 40,
                                height: 40,
                                borderRadius: "8px",
                                backgroundColor: "#0b243d",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }}
                        >
                            <WorkspacePremiumIcon sx={{ color: "#ffc845", fontSize: 24 }} />
                        </Box>
                        <Box sx={{ flex: 1, maxWidth: "300px" }}>
                            <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 1, }}>
                                <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#111827", lineHeight: 1.3 }}>
                                    {usuario?.plano}
                                </Typography>
                                <Chip
                                    label={usuario?.statusPlano}
                                    size="small"
                                    sx={{ backgroundColor: "#dcfce7", color: "#15803d", fontWeight: 700, fontSize: 10, height: 20, letterSpacing: 0.5 }}
                                />
                            </Box>
                            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>
                                {usuario?.descricaoPlano}
                            </Typography>
                            <Typography sx={{ fontSize: 11, color: "#6b7280", textDecoration: "underline", cursor: "pointer", textAlign: "right" }} onClick={() => navigate("../Dashboard/Assinatura")}>
                                Ver mais
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                <Box
                    data-tour="indicadores"
                    sx={{
                        mt: 2,
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(4, 1fr)" },
                        gap: 2,
                    }}
                >
                    <Box sx={cardSx}>
                        <CardHeader titulo="Faturamento bruto" icone={<LocalAtmOutlinedIcon />} />
                        <Box>
                            <Typography sx={valorSx}>{resumo.faturamento.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</Typography>
                            <Box sx={{ mt: 0.5, display: "flex", alignItems: "center", gap: 1 }}>
                                <Chip
                                    icon={<TrendingUpIcon sx={{ fontSize: "14px !important", color: "#15803d !important" }} />}
                                    label={resumo.variacaoFaturamento + "%"}
                                    size="small"
                                    sx={{ backgroundColor: "#dcfce7", color: "#15803d", fontWeight: 600, fontSize: 11, height: 20 }}
                                />
                                <Typography sx={{ fontSize: 12, color: "#6b7280" }}>vs. mês anterior</Typography>
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={cardSx}>
                        <CardHeader titulo="Notas emitidas" icone={<ReceiptLongOutlinedIcon />} />
                        <Box>
                            <Typography sx={valorSx}>{resumo.notasEmitidas} notas</Typography>
                            <Box sx={{ mt: 0.5, display: "flex", alignItems: "center", flexWrap: "wrap", fontSize: 12 }}>
                                <Typography sx={{ fontSize: 12, color: "#374151" }}>Competência atual</Typography>
                                {dot}
                                <Typography sx={{ fontSize: 12, color: "#6b7280" }}>Média de {resumo.mediaPorNota.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} / nota</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>

                <Box
                    data-tour="acesso-rapido"
                    sx={{
                        mt: 2,
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 1.5,
                        backgroundColor: "#fff",
                        border: "1px solid #e5e7eb",
                        borderRadius: "12px",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                        p: 2,
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mr: 1, width: { xs: "100%", md: "auto" } }}>
                        <BoltIcon sx={{ fontSize: 18, color: "#6b7280" }} />
                        <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.8, color: "#374151", textTransform: "uppercase" }}>
                            Acesso rápido
                        </Typography>
                    </Box>
                    <Button
                        variant="contained"
                        startIcon={<AddCircleOutlineIcon />}
                        onClick={() => navigate("../Dashboard/EmitirNotaServico")}
                        sx={{
                            ...botaoAcaoSx,
                            fontWeight: 700,
                            fontSize: 14,
                            color: "#111827",
                            backgroundColor: "#ffc845",
                            "& svg": { fontSize: 20, color: "#111827" },
                            "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" },
                        }}
                    >
                        Emitir NFS-e
                    </Button>
                    {acoesRapidas.map((acao) => (
                        <Button key={acao.label} variant="contained" startIcon={acao.icone} onClick={acao.rota ? () => navigate(acao.rota) : undefined} sx={{ ...botaoAcaoSx, ...(acao.corIcone && { "& svg": { fontSize: 18, color: acao.corIcone } }) }}>
                            {acao.label}
                        </Button>
                    ))}
                </Box>

                <Box
                    sx={{
                        mt: 2,
                        pb: 4,
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "minmax(0, 3fr) minmax(0, 2fr)" },
                        gap: 2,
                    }}
                >
                    {/* Faturamento mensal */}
                    <Box data-tour="faturamento" sx={{ ...cardSx, p: { xs: 2, md: 3 } }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 2, flexWrap: "wrap" }}>
                            <Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                                    <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#111827" }}>Faturamento Mensal</Typography>
                                    <Chip
                                        label={faturamentoMensal.variacao}
                                        size="small"
                                        sx={{ backgroundColor: "#dcfce7", color: "#15803d", fontWeight: 600, fontSize: 11, height: 20 }}
                                    />
                                </Box>
                                <Typography sx={{ mt: 0.5, fontSize: 12, color: "#6b7280" }}>
                                    Histórico consolidado dos últimos 6 meses ({faturamentoMensal.meses[0].mes} a {faturamentoMensal.meses[faturamentoMensal.meses.length - 1].mes})
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, backgroundColor: "#f3f4f6", borderRadius: "8px", px: 1.5, py: 0.75 }}>
                                <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#0b243d" }} />
                                <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>Média: {faturamentoMensal.media}</Typography>
                            </Box>
                        </Box>

                        <Box sx={{ position: "relative", height: 170, ml: 4, mt: 4 }}>
                            {[20000, 35000, 50000].map((linha) => (
                                <Box key={linha} sx={{ position: "absolute", left: 0, right: 0, bottom: `${(linha / escalaGrafico) * 100}%`, borderTop: "1px dashed #e5e7eb" }}>
                                    <Typography sx={{ position: "absolute", left: -32, top: -8, fontSize: 10, color: "#9ca3af" }}>{linha / 1000}k</Typography>
                                </Box>
                            ))}
                            <Box sx={{ position: "absolute", inset: 0, display: "flex", alignItems: "flex-end", justifyContent: "space-around", gap: 2 }}>
                                {faturamentoMensal.meses.map((m) => (
                                    <Box key={m.mes} sx={{ flex: 1, maxWidth: 52, height: "100%", display: "flex", flexDirection: "column", justifyContent: "flex-end", alignItems: "center" }}>
                                        <Typography sx={{ flexShrink: 0, mb: 0.5, fontSize: 11, fontWeight: 700, color: "#111827" }}>
                                            {(m.valor / 1000).toFixed(1)}k
                                        </Typography>
                                        <Box
                                            sx={{
                                                flexShrink: 0,
                                                width: "100%",
                                                height: `${(m.valor / escalaGrafico) * 100}%`,
                                                borderRadius: "6px 6px 0 0",
                                                background: m.atual ? "#ffc845" : "linear-gradient(180deg, #334155 0%, #64748b 100%)",
                                                borderTop: m.atual ? "3px solid #111827" : "none",
                                            }}
                                        />
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                        <Box sx={{ ml: 4, mt: 1, display: "flex", justifyContent: "space-around", gap: 2 }}>
                            {faturamentoMensal.meses.map((m) => (
                                <Typography key={m.mes} sx={{ flex: 1, maxWidth: 52, textAlign: "center", fontSize: 11, fontWeight: m.atual ? 700 : 400, color: m.atual ? "#111827" : "#6b7280" }}>
                                    {m.mes}
                                </Typography>
                            ))}
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Box sx={{ width: 10, height: 10, borderRadius: "2px", backgroundColor: "#ffc845" }} />
                                <Typography sx={{ fontSize: 12, color: "#374151" }}>Mês Atual (Em andamento)</Typography>
                            </Box>
                            <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                Projeção de fechamento: <Box component="span" sx={{ color: "#111827", fontWeight: 700 }}>{faturamentoMensal.projecao}</Box>
                            </Typography>
                        </Box>
                    </Box>

                    {/* Situação da empresa */}
                    <Box data-tour="situacao" sx={{ ...cardSx, justifyContent: "flex-start", gap: 1.5, p: { xs: 2, md: 3 } }}>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#111827" }}>Situação da Empresa</Typography>
                                <Chip
                                    label={situacaoEmpresa?.status}
                                    size="small"
                                    sx={{ backgroundColor: situacaoEmpresa?.status === "Pendente" ? "#fee2e2" : "#dcfce7", color: situacaoEmpresa?.status === "Pendente" ? "#b91c1c" : "#15803d", fontWeight: 600, fontSize: 11, height: 20 }}
                                />
                            </Box>
                            <ViewQuiltOutlinedIcon sx={{ fontSize: 20, color: "#6b7280" }} />
                        </Box>
                        <Box sx={{ backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "10px", p: 1.5 }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <BusinessOutlinedIcon sx={{ fontSize: 18, color: "#374151" }} />
                                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>Minha empresa</Typography>
                                </Box>
                            </Box>
                            <Box sx={{ mt: 1, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0 }}>
                                    <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Status:</Typography>
                                    <Box
                                        sx={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 0.75,
                                            backgroundColor: situacaoEmpresa?.status === "Pendente" ? "#fef3c7" : "#dcfce7",
                                            border: "1px solid " + (situacaoEmpresa?.status === "Pendente" ? "#fde68a" : "#dcfce7"),
                                            borderRadius: "999px",
                                            px: 1,
                                            py: 0.25,
                                        }}
                                    >
                                        <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: situacaoEmpresa?.status === "Pendente" ? "#d97706" : "#16a34a", flexShrink: 0 }} />
                                        <Typography sx={{ fontSize: 11, fontWeight: 600, color: situacaoEmpresa?.status === "Pendente" ? "#b45309" : "#16a34a", whiteSpace: "nowrap" }}>
                                            {situacaoEmpresa?.status === "Pendente" ? "Empresa em configuração" : "Empresa ativa"}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Button
                                    size="small"
                                    endIcon={<ChevronRightIcon sx={{ fontSize: "16px !important" }} />}
                                    onClick={() => navigate("../Dashboard/FichaCadastral")}
                                    sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, color: "#111827", p: 0, minWidth: 0, "&:hover": { backgroundColor: "transparent", textDecoration: "underline" } }}
                                >
                                    Acessar
                                </Button>
                            </Box>
                        </Box>
                        <Box sx={{ backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "10px", p: 1.5 }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <AssignmentIndOutlinedIcon sx={{ fontSize: 18, color: "#374151" }} />
                                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>Ficha cadastral dos sócios</Typography>
                                </Box>
                                <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>{situacaoEmpresa?.fichaProgresso}% concluída</Typography>
                            </Box>
                            <LinearProgress
                                variant="determinate"
                                value={situacaoEmpresa?.fichaProgresso || 0}
                                sx={{ mt: 1, height: 6, borderRadius: 3, backgroundColor: "#e5e7eb", "& .MuiLinearProgress-bar": { backgroundColor: "#0b243d", borderRadius: 3 } }}
                            />
                            <Box sx={{ mt: 1, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                <Typography sx={{ fontSize: 11, color: "#6b7280" }}>
                                    {situacaoEmpresa?.fichaPendente ? `Pendente: ${situacaoEmpresa.fichaPendente}` : "Ficha completa"}
                                </Typography>
                                <Button
                                    size="small"
                                    endIcon={<ChevronRightIcon sx={{ fontSize: "16px !important" }} />}
                                    onClick={() => navigate("../Dashboard/FichaCadastral")}
                                    sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, color: "#111827", p: 0, minWidth: 0, "&:hover": { backgroundColor: "transparent", textDecoration: "underline" } }}
                                >
                                    {situacaoEmpresa?.fichaPendente ? "Completar" : "Ver"}
                                </Button>
                            </Box>
                        </Box>

                        {situacaoEmpresa?.itens?.map((item) => {

                            return (
                                <Box
                                    key={item.titulo}
                                    onClick={item.rota ? () => navigate(item.rota) : undefined}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                        backgroundColor: "#f9fafb",
                                        border: "1px solid #e5e7eb",
                                        borderRadius: "10px",
                                        p: 1.5,
                                        cursor: item.rota ? "pointer" : "default",
                                        "&:hover": item.rota
                                            ? {
                                                backgroundColor: "#f3f4f6",
                                            }
                                            : {},
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            color: item.alerta ? "#d97706" : "#16a34a",
                                            "& svg": {
                                                fontSize: 18,
                                            },
                                        }}
                                    >
                                        {icones[item.icone] && React.createElement(icones[item.icone])}
                                    </Box>

                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                        <Typography
                                            sx={{
                                                fontSize: 13,
                                                fontWeight: 600,
                                                color: "#111827",
                                            }}
                                        >
                                            {item.titulo}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                fontSize: 11,
                                                color: "#6b7280",
                                            }}
                                        >
                                            {item.descricao}
                                        </Typography>
                                    </Box>

                                    <Chip
                                        label={item.status}
                                        size="small"
                                        sx={{
                                            backgroundColor: item.alerta ? "#fef3c7" : "#dcfce7",
                                            color: item.alerta ? "#b45309" : "#15803d",
                                            fontWeight: 700,
                                            fontSize: 10,
                                            height: 20,
                                            letterSpacing: 0.5,
                                        }}
                                    />
                                </Box>
                            );
                        })}
                    </Box>

                    {/* Notas fiscais recentes */}
                    <Box data-tour="notas" sx={{ ...cardSx, justifyContent: "flex-start", gap: 1.5, p: { xs: 2, md: 3 } }}>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#111827" }}>Notas Fiscais Recentes</Typography>
                                {dot}
                                <Typography sx={{ fontSize: 12, color: "#6b7280" }}>{notasRecentes.competencia}</Typography>
                            </Box>
                            <Button
                                size="small"
                                endIcon={<ArrowForwardIcon sx={{ fontSize: "16px !important" }} />}
                                onClick={() => navigate("../Dashboard/NotasFiscaisEmitidas")}
                                sx={{ textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", "&:hover": { backgroundColor: "#f3f4f6" } }}
                            >
                                Ver todas
                            </Button>
                        </Box>

                        <Box sx={{ overflowX: "auto" }}>
                            <Box sx={{ minWidth: 480 }}>
                                <Box
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: colunasNotas,
                                        gap: 1,
                                        backgroundColor: "#f3f4f6",
                                        borderRadius: "6px",
                                        px: 1.5,
                                        py: 1,
                                        "& p": { fontSize: 11, fontWeight: 700, letterSpacing: 0.6, color: "#6b7280", textTransform: "uppercase" },
                                    }}
                                >
                                    <Typography>Cliente / Tomador</Typography>
                                    <Typography sx={{ textAlign: "right" }}>Valor</Typography>
                                    <Typography sx={{ textAlign: "center" }}>Emissão</Typography>
                                    <Typography sx={{ textAlign: "center" }}>Status</Typography>
                                </Box>
                                {!notasRecentes.notas?.length && (
                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5, py: 4, px: 1.5, textAlign: "center", borderBottom: "1px solid #f3f4f6" }}>
                                        <ReceiptLongOutlinedIcon sx={{ fontSize: 32, color: "#9ca3af" }} />
                                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>Nenhuma nota emitida</Typography>
                                        <Typography sx={{ fontSize: 12, color: "#6b7280" }}>Ainda não há notas fiscais emitidas nesta competência.</Typography>
                                    </Box>
                                )}
                                {notasRecentes.notas?.map((nota) => (
                                    <Box
                                        key={nota.numero}
                                        sx={{ display: "grid", gridTemplateColumns: colunasNotas, gap: 1, alignItems: "center", px: 1.5, py: 1.25, borderBottom: "1px solid #f3f4f6" }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
                                            <Avatar variant="rounded" sx={{ width: 28, height: 28, fontSize: 10, fontWeight: 700, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "6px" }}>
                                                {iniciais(nota.tomador)}
                                            </Avatar>
                                            <Box sx={{ minWidth: 0 }}>
                                                <Typography noWrap sx={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>{nota.tomador}</Typography>
                                                <Typography sx={{ fontSize: 11, color: "#6b7280" }}>NFS-e #{nota.numero}</Typography>
                                            </Box>
                                        </Box>
                                        <Typography sx={{ textAlign: "right", fontSize: 13, fontWeight: 700, color: "#111827" }}>{nota.valor}</Typography>
                                        <Typography sx={{ textAlign: "center", fontSize: 12, color: "#374151" }}>{nota.emissao}</Typography>
                                        <Box sx={{ textAlign: "center" }}>
                                            <Chip label={nota.status} size="small" sx={{ backgroundColor: "#dcfce7", color: "#15803d", fontWeight: 600, fontSize: 10, height: 20 }} />
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        </Box>

                        <Box sx={{ mt: "auto", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 1.5, py: 1 }}>
                            <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                Faturamento total em aberto nesta competência: <Box component="span" sx={{ color: "#111827", fontWeight: 700 }}>{notasRecentes.totalAberto}</Box>
                            </Typography>
                            <Button
                                size="small"
                                startIcon={<AddIcon sx={{ fontSize: "16px !important" }} />}
                                onClick={() => navigate("../Dashboard/EmitirNotaServico")}
                                sx={{ textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", "&:hover": { backgroundColor: "#e5e7eb" } }}
                            >
                                Emitir nova nota fiscal
                            </Button>
                        </Box>
                    </Box>

                    {/* Plantão contábil */}
                    <Box data-tour="plantao" sx={{ ...cardSx, backgroundColor: "#0b243d", border: "none", color: "#fff", gap: 2, p: { xs: 2, md: 3 } }}>
                        <Box>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                <Chip
                                    label="Plantão contábil"
                                    size="small"
                                    sx={{ backgroundColor: "rgba(255, 200, 69, 0.15)", color: "#ffc845", fontWeight: 700, fontSize: 10, height: 20, letterSpacing: 0.6, textTransform: "uppercase" }}
                                />
                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                                    <Box sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#22c55e", boxShadow: "0 0 0 3px rgba(34, 197, 94, 0.2)" }} />
                                    <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#4ade80" }}>Online agora</Typography>
                                </Box>
                            </Box>
                            <Typography sx={{ mt: 1.5, fontSize: 20, fontWeight: 700 }}>Precisa de ajuda?</Typography>
                            <Typography sx={{ mt: 0.5, fontSize: 13, color: "#cbd5e1" }}>
                                Fale com seu contador especialista em contabilidade médica e planejamento de pró-labore.
                            </Typography>

                            <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1.5, backgroundColor: "rgba(255, 255, 255, 0.06)", borderRadius: "10px", p: 1.5 }}>
                                <Avatar sx={{ width: 40, height: 40, fontSize: 14, fontWeight: 700, color: "#0b243d", backgroundColor: "#ffc845", border: "2px solid #ffc845" }}>
                                    {iniciais(contador.nome)}
                                </Avatar>
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{contador.nome}</Typography>
                                    <Typography noWrap sx={{ fontSize: 11, color: "#94a3b8" }}>
                                        {contador.especialidade}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                        <Box>
                            {/* TODO: ligar ao fluxo de atendimento com o contador */}
                            <Button
                                fullWidth
                                variant="contained"
                                startIcon={<ChatOutlinedIcon />}
                                sx={{ ...botaoAcaoSx, fontWeight: 700, fontSize: 14, color: "#111827", backgroundColor: "#ffc845", py: 1.25, "& svg": { fontSize: 20, color: "#111827" }, "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" } }}
                            >
                                Iniciar atendimento
                            </Button>
                            <Typography sx={{ mt: 1, textAlign: "center", fontSize: 11, color: "#94a3b8" }}>
                                Tempo de resposta estimado: {contador.tempoResposta}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

const DashboardComTour = () => (
    <TourDashboard>
        <Dashboard />
    </TourDashboard>
);

export default DashboardComTour;
